<template>
  <v-container fluid>
    <v-app-bar app>
      <v-btn icon to="/courier">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
      <v-toolbar-title>Request Delivery or Pickup</v-toolbar-title>
      <!-- <v-spacer></v-spacer> -->
      <!-- <v-btn icon to="/delivery">
        <v-icon>mdi-close</v-icon>
      </v-btn>-->
    </v-app-bar>
    <div class="pt-4 pb-4 pl-4 pr-4">
      <v-card class="login-form">
        <v-card-text class="pb-0">
          <v-form v-model="valid" ref="form">
            <h2 class="headline mb-4">Request</h2>
            <v-select
              v-model="text12"
              :items="items"
              item-text="descripcion"
              item-value="id_domicilio"
              label="Tipo de servicio"
              solo
              required
            ></v-select>

            <v-text-field
              solo
              required
              :rules="required"
              v-model="text7"
              label="Address"
              type="text"
              :disabled="addres_disable"
            ></v-text-field>
            <v-btn class="mt-n2 mb-4" color="primary" rounded @click="useAnother">{{btnAddressText}}</v-btn>
            <v-text-field
              solo
              required
              :rules="required"
              v-model="text8"
              label="Phone"
              type="text"
            ></v-text-field>
            <v-text-field solo required v-model="text9" label="WhatsApp" type="text"></v-text-field>
            <v-textarea solo v-model="text6" label="comment"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!valid" block color="primary" @click="validateLogin">Send</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-snackbar :timeout="2000" v-model="snackbarLogin">
      {{ snackbarLoginText }}
      <v-btn text @click.native="snackbarLogin = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  data() {
    return {
      clipped: false,
      currentUser: undefined,
      noData: false,
      loading: false,
      text6: "",
      text7: "",
      text8: "",
      text9: "",
      text12: "",
      valid: false,
      required: [(v) => !!v || Language[this.lg].the_field_is_required],
      addres: "",
      items: [],
      addres_disable: true,
      btnAddressText: "Usar otra dirección",
      snackbarLogin: false,
      snackbarLoginText: "Solicitud enviada",
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    profile: function () {
      return this.$store.getters.profile;
    },
    login() {
      return this.$store.getters.login;
    },
  },
  mounted() {
    console.log(Server);
    // if (this.currentUser != undefined) {
    // }
    // else
    if (this.user.userName != null) {
      this.currentUser = this.user;
      this.text7 = this.profile[0].direccion_cliente;
      this.text8 = this.profile[0].telefono1_cliente;
      this.getData();
    }
  },
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      (newValue) => {
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            this.getData();
          }
        }
      }
    );
  },
  methods: {
    useAnother() {
      console.log(this.addres_disable);
      if (this.addres_disable === true) {
        this.btnAddressText = "Use my address";
        this.addres_disable = false;
        this.text7 = "";
      } else {
        this.btnAddressText = "Use another address";
        this.addres_disable = true;
        this.text7 = this.profile[0].direccion_cliente;
      }
    },
    getData() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.domicilioInf, formData).then(
        (response) => {
          console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.items = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "Try again later";
        }
      );
    },
    validateLogin: function () {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      formData.append("text6", this.text6);
      formData.append("text7", this.text7);
      formData.append("text8", this.text8);
      formData.append("text9", this.text9);
      formData.append("text12", this.text12);

      console.log(Server.createPrealerta);
      Helpers.getJson(
        Server.createDeliveryRequest,
        "POST",
        formData
        // json => {}
      );
      this.$router.push("delivery");
    },
  },
  name: "App",
};
</script>

this.snackbarLogin = true;
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
